(function () {
  'use strict';


  /* ==========================================================================
     HEADER HEIGHT
     ========================================================================== */

  function updateHeaderHeight() {
    var headerSection = document.getElementById('shopify-section-header');

    if (!headerSection) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-height',
      headerSection.offsetHeight + 'px'
    );
  }


  /* ==========================================================================
     MAIN COUNTRY SELECTOR
     ========================================================================== */

  function getMainToggle(selector) {
    return selector.querySelector(
      '.FullordCountrySelector__Toggle'
    );
  }


  function getMainMenu(selector) {
    return selector.querySelector(
      '.FullordCountrySelector__Menu'
    );
  }


  /* ==========================================================================
     GENERIC ACCORDION HELPERS
     ========================================================================== */

  function getGroupToggle(group) {
    return group.querySelector(
      '.FullordCountrySelector__GroupToggle'
    );
  }


  function getGroupPanel(group) {
    return group.querySelector(
      '.FullordCountrySelector__GroupPanel'
    );
  }


  function closeGroup(group) {
    var toggle = getGroupToggle(group);
    var panel = getGroupPanel(group);

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }


  function openGroup(group) {
    var toggle = getGroupToggle(group);
    var panel = getGroupPanel(group);

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }


  function closeAllGroups(selector, exceptGroup) {
    var groups = selector.querySelectorAll(
      '.FullordCountrySelector__Group'
    );

    Array.prototype.forEach.call(
      groups,
      function (group) {
        if (group !== exceptGroup) {
          closeGroup(group);
        }
      }
    );

    /*
     * Temporary compatibility with the previous
     * Other countries implementation.
     */
    closeLegacyOtherCountries(selector);
  }


  function toggleGroup(selector, group) {
    var toggle = getGroupToggle(group);

    if (!toggle) {
      return;
    }

    var isOpen =
      toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closeGroup(group);
      return;
    }

    /*
     * Keep the dropdown compact:
     * only one regional accordion is open at a time.
     */
    closeAllGroups(selector, group);

    openGroup(group);
  }


  /* ==========================================================================
     AUTO-OPEN CURRENT REGION
     ========================================================================== */

  function openActiveCountryGroup(selector) {
    var groups = selector.querySelectorAll(
      '.FullordCountrySelector__Group'
    );

    var activeGroup = null;

    Array.prototype.forEach.call(
      groups,
      function (group) {
        var toggle = getGroupToggle(group);
        var panel = getGroupPanel(group);

        if (!toggle || !panel) {
          return;
        }

        /*
         * A regional group is considered active when it
         * contains the currently selected Shopify country.
         *
         * This means the same logic will automatically work
         * later for Europe, Asia, Middle East, etc.
         */
        var activeCountry = group.querySelector(
          '.FullordCountrySelector__Option.is-active'
        );

        if (activeCountry && !activeGroup) {
          activeGroup = group;
        }
      }
    );

    if (!activeGroup) {
      return;
    }

    closeAllGroups(selector, activeGroup);
    openGroup(activeGroup);
  }


  /* ==========================================================================
     TEMPORARY LEGACY SUPPORT
     Previous Other countries classes
     ========================================================================== */

  function getLegacyOtherToggle(selector) {
    return selector.querySelector(
      '.FullordCountrySelector__OtherToggle'
    );
  }


  function getLegacyOtherPanel(selector) {
    return selector.querySelector(
      '.FullordCountrySelector__OtherPanel'
    );
  }


  function closeLegacyOtherCountries(selector) {
    var toggle = getLegacyOtherToggle(selector);
    var panel = getLegacyOtherPanel(selector);

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }


  function openLegacyOtherCountries(selector) {
    var toggle = getLegacyOtherToggle(selector);
    var panel = getLegacyOtherPanel(selector);

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }


  function toggleLegacyOtherCountries(selector) {
    var toggle = getLegacyOtherToggle(selector);

    if (!toggle) {
      return;
    }

    var isOpen =
      toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closeLegacyOtherCountries(selector);
      return;
    }

    closeAllGroups(selector);

    openLegacyOtherCountries(selector);
  }


  /* ==========================================================================
     CLOSE / OPEN MAIN SELECTOR
     ========================================================================== */

  function closeSelector(selector) {
    var toggle = getMainToggle(selector);
    var menu = getMainMenu(selector);

    if (!toggle || !menu) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'false');
    menu.hidden = true;

    /*
     * Collapse every internal accordion when
     * the main country selector is closed.
     */
    closeAllGroups(selector);
    closeLegacyOtherCountries(selector);
  }


  function openSelector(selector) {
    var toggle = getMainToggle(selector);
    var menu = getMainMenu(selector);

    if (!toggle || !menu) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'true');
    menu.hidden = false;

    /*
     * If the current country belongs to a regional group,
     * automatically reveal that group.
     *
     * Example:
     * France -> Europe opens automatically.
     */
    openActiveCountryGroup(selector);
  }


  function closeAllSelectors(exceptSelector) {
    var selectors = document.querySelectorAll(
      '[data-fullord-country-selector]'
    );

    Array.prototype.forEach.call(
      selectors,
      function (selector) {
        if (selector !== exceptSelector) {
          closeSelector(selector);
        }
      }
    );
  }


  /* ==========================================================================
     ESCAPE KEY
     ========================================================================== */

  function getOpenGroup(selector) {
    var toggles = selector.querySelectorAll(
      '.FullordCountrySelector__GroupToggle[aria-expanded="true"]'
    );

    if (!toggles.length) {
      return null;
    }

    return toggles[0].closest(
      '.FullordCountrySelector__Group'
    );
  }


  function handleEscape(selector) {
    var mainToggle = getMainToggle(selector);

    /*
     * First close a regional accordion if one is open.
     */
    var openGroupElement = getOpenGroup(selector);

    if (openGroupElement) {
      var groupToggle = getGroupToggle(openGroupElement);

      closeGroup(openGroupElement);

      if (groupToggle) {
        groupToggle.focus();
      }

      return;
    }


    /*
     * Temporary legacy Other countries accordion.
     */
    var legacyOtherToggle =
      getLegacyOtherToggle(selector);

    if (
      legacyOtherToggle &&
      legacyOtherToggle.getAttribute('aria-expanded') === 'true'
    ) {
      closeLegacyOtherCountries(selector);
      legacyOtherToggle.focus();

      return;
    }


    /*
     * If no internal accordion is open,
     * close the entire country selector.
     */
    closeSelector(selector);

    if (mainToggle) {
      mainToggle.focus();
    }
  }


  /* ==========================================================================
     INITIALIZE GENERIC ACCORDIONS
     ========================================================================== */

  function initGroupAccordions(selector) {
    var groups = selector.querySelectorAll(
      '.FullordCountrySelector__Group'
    );

    Array.prototype.forEach.call(
      groups,
      function (group) {
        var toggle = getGroupToggle(group);
        var panel = getGroupPanel(group);

        if (!toggle || !panel) {
          return;
        }

        /*
         * Prevent duplicate listeners during Shopify
         * Theme Editor section reloads.
         */
        if (
          toggle.getAttribute(
            'data-fullord-group-toggle-initialized'
          ) === 'true'
        ) {
          return;
        }

        toggle.setAttribute(
          'data-fullord-group-toggle-initialized',
          'true'
        );

        /*
         * Initial state.
         * The active region will be reopened when
         * the main selector itself is opened.
         */
        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;


        toggle.addEventListener(
          'click',
          function (event) {
            event.preventDefault();

            toggleGroup(selector, group);
          }
        );
      }
    );
  }


  /* ==========================================================================
     INITIALIZE LEGACY OTHER COUNTRIES
     ========================================================================== */

  function initLegacyOtherCountries(selector) {
    var toggle = getLegacyOtherToggle(selector);
    var panel = getLegacyOtherPanel(selector);

    if (!toggle || !panel) {
      return;
    }

    if (
      toggle.getAttribute(
        'data-fullord-legacy-other-initialized'
      ) === 'true'
    ) {
      return;
    }

    toggle.setAttribute(
      'data-fullord-legacy-other-initialized',
      'true'
    );

    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;


    toggle.addEventListener(
      'click',
      function (event) {
        event.preventDefault();

        toggleLegacyOtherCountries(selector);
      }
    );
  }


  /* ==========================================================================
     INITIALIZE ONE COUNTRY SELECTOR
     ========================================================================== */

  function initSelector(selector) {
    var mainToggle = getMainToggle(selector);
    var mainMenu = getMainMenu(selector);

    if (!mainToggle || !mainMenu) {
      return;
    }


    /*
     * Regional accordions must also be initialized
     * when Shopify reloads the section.
     */
    initGroupAccordions(selector);
    initLegacyOtherCountries(selector);


    /*
     * Avoid duplicating the main selector listeners.
     */
    if (
      selector.getAttribute(
        'data-fullord-country-selector-initialized'
      ) === 'true'
    ) {
      return;
    }

    selector.setAttribute(
      'data-fullord-country-selector-initialized',
      'true'
    );


    /* --------------------------------------------------------------------------
       Initial state
       -------------------------------------------------------------------------- */

    mainToggle.setAttribute('aria-expanded', 'false');
    mainMenu.hidden = true;

    closeAllGroups(selector);
    closeLegacyOtherCountries(selector);


    /* --------------------------------------------------------------------------
       Main toggle
       -------------------------------------------------------------------------- */

    mainToggle.addEventListener(
      'click',
      function (event) {
        event.preventDefault();

        var isOpen =
          mainToggle.getAttribute('aria-expanded') === 'true';

        closeAllSelectors(selector);

        if (isOpen) {
          closeSelector(selector);
        } else {
          openSelector(selector);
        }
      }
    );


    /* --------------------------------------------------------------------------
       Keyboard accessibility
       -------------------------------------------------------------------------- */

    selector.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key !== 'Escape' &&
          event.key !== 'Esc'
        ) {
          return;
        }

        handleEscape(selector);
      }
    );
  }


  /* ==========================================================================
     INITIALIZE ALL SELECTORS
     ========================================================================== */

  function initCountrySelectors() {
    var selectors = document.querySelectorAll(
      '[data-fullord-country-selector]'
    );

    Array.prototype.forEach.call(
      selectors,
      function (selector) {
        initSelector(selector);
      }
    );

    /*
     * Let the browser finish rendering the additional
     * header row before measuring the Prestige header.
     */
    window.requestAnimationFrame(
      function () {
        updateHeaderHeight();
      }
    );
  }


  /* ==========================================================================
     CLICK OUTSIDE
     ========================================================================== */

  document.addEventListener(
    'click',
    function (event) {
      var selectors = document.querySelectorAll(
        '[data-fullord-country-selector]'
      );

      Array.prototype.forEach.call(
        selectors,
        function (selector) {
          if (!selector.contains(event.target)) {
            closeSelector(selector);
          }
        }
      );
    }
  );


  /* ==========================================================================
     INITIAL PAGE LOAD
     ========================================================================== */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCountrySelectors
    );
  } else {
    initCountrySelectors();
  }


  /* ==========================================================================
     FULL PAGE LOAD
     ========================================================================== */

  window.addEventListener(
    'load',
    function () {
      updateHeaderHeight();
    }
  );


  /* ==========================================================================
     VIEWPORT RESIZE
     ========================================================================== */

  var resizeTimer;

  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(
        function () {
          updateHeaderHeight();
        },
        100
      );
    }
  );


  /* ==========================================================================
     SHOPIFY THEME EDITOR
     ========================================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {
      initCountrySelectors();
    }
  );

})();